import * as React from 'react';
import { cn } from 'lib/utils';

import { PageHeaderForFiltersContext } from './context';
import { FiltersToggleButton } from './filters-toggle-button';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  headerTitle?: React.ReactNode;
  defaultOpen?: boolean;
}

export const PageHeaderForFilters = ({
                                       headerTitle,
                                       children,
                                       className,
                                       defaultOpen,
                                       ...props
                                     }: Props) => {
  const [open, setOpen] = React.useState(!!defaultOpen);

  return (
    <PageHeaderForFiltersContext.Provider
      value={{ open, setOpen }}
    >
      <div
        {...props}
        className={cn(
          'flex flex-col w-full rounded-md bg-white px-6 py-4 shadow-sm shadow-slate-300',
          className,
        )}
      >
        <div className={'flex flex-row items-center'}>
          {headerTitle}
          <FiltersToggleButton className={'ml-auto'} />
        </div>
        <div
          className={cn(
            'border-t-slate-300 border-t pt-6 mt-4 hidden',
            open && 'flex',
          )}
        >
          {children}
        </div>
      </div>
    </PageHeaderForFiltersContext.Provider>
  );
};
